import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import Link from 'next/link'
import NumberFormat from "react-number-format"

import type { ListItem, Pagination } from '@/modules/project'

import Dayjs from '@/components/dayjs'
import { Type, State, Step } from '@/components/typeConverter'
import { PaginationComponent, IPagination } from '@/components/pagination'

import SearchForm from '../decision/SearchForm'
import style from './items.module.css'


interface IProps {
  items: ListItem[] | []
  pagination: Pagination
}


const Component: NextPage<IProps> = ({ items, pagination }) => {
  const Router = useRouter();
  const paginationInfo: IPagination = {
    limit: pagination.limit,
    pageItemLength: 10,
    totalPages: pagination.totalPage,
    totalRecords: pagination.totalRecord,
  };

  return (
    <div className='flex flex-col items-center'>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex flex-col items-center justify-center my-16'>
        <div className='w-full'>
          <h1 className={`${style.h1}`}>주민의견 제출</h1>

          <div className='my-4'>
            <SearchForm />
          </div>

          <div className='mt-10'>
            <h2 className={style.h2}>
              총
              <NumberFormat value={pagination.totalRecord || 0} className='text-[#009BFA] pl-2 pr-0' displayType='text' thousandSeparator={true} />
              건
            </h2>
            <div className='mt-8'>
              <table className={style.table}>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>승인기관</th>
                    <th>사업명</th>
                    <th>시행자</th>
                    <th>사업분야</th>
                    <th>진행단계</th>
                    <th>진행상태</th>
                    <th>등록일</th>
                  </tr>
                </thead>
                <tbody>
                  {items && items.map((item, index) => (
                    <tr key={index} className="hover:bg-blue-50" onClick={() => (Router.push(`/opinion/participation/${item.idx}`))}>
                      <td><Link href={`/opinion/participation/${item.idx}`}><a>{item.idx}</a></Link></td>
                      <td>{item.approvalInstitution}</td>
                      <td className='!text-left'><Link href={`/opinion/participation/${item.idx}`}><a>{item.name}</a></Link></td>
                      <td>{item.businessName}</td>
                      <td><Type>{item.type}</Type></td>
                      <td><Step>{item.step}</Step></td>
                      <td><State>{item.state}</State></td>
                      <td><Dayjs format="dateDot">{item.createdAt}</Dayjs></td>
                    </tr>
                  ))}
                  {items && items.length === 0 && (
                    <tr className='hover:!bg-white odd:!bg-white even:!bg-white hover:!cursor-auto'>
                      <td colSpan={8} className='text-center py-60'>
                        조회된 데이터가 없습니다.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className='my-16'>
            {(items && pagination) && <PaginationComponent {...paginationInfo} />}
          </div>

        </div>
      </div>
    </div>
  )
}

export default Component
